module.exports = __webpack_public_path__ + "media/assets/images/lib/select2x2-688bccf95583ddf2ba42dd5df5e2c6a5.png";